import { useEffect, useState } from 'react';

// Mirrors this app's own `lg:hidden` breakpoint (1024px) used for the header
// hamburger menu, so "mobile" here means the same thing it means everywhere else in the UI.
const MOBILE_MEDIA_QUERY = '(max-width: 1023px)';

const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_MEDIA_QUERY).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(MOBILE_MEDIA_QUERY);
    const listener = (event: MediaQueryListEvent) => setIsMobile(event.matches);

    mediaQueryList.addEventListener('change', listener);
    return () => mediaQueryList.removeEventListener('change', listener);
  }, []);

  return isMobile;
};

export default useIsMobile;
